import { useState } from 'react';

import { InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { makeStyles } from '@mui/styles';

import './MaterialDropDown.css';

const useStyles = makeStyles((theme) => ({
  select: {
    padding: '5px 10px',
    fontSize: '12px',
    lineHeight: '20px',
    minHeight: 'auto',
    whiteSpace: 'pre',
  },
}));

const MaterialDropDown = ({ label, options, selectedValue, onChange, isNotDesktop }) => {
  const [value, setValue] = useState(selectedValue);
  const classes = useStyles();
  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={handleChange}
        className={isNotDesktop ? classes.select : ''}
      >
        {options?.map((option, index) => (
          <MenuItem key={index} value={option.value} className={isNotDesktop ? classes.select : ''}>
            {option.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MaterialDropDown;
